import "./perfil.css"

const Perfil = () => {
  return (
    <div>
        <h1>Perfil privado solo con verificacion</h1>
    </div>
  )
}

export default Perfil